import { render, staticRenderFns } from "./PersonalAccidentComponent.vue?vue&type=template&id=4d3d8d80&scoped=true&"
import script from "./PersonalAccidentComponent.vue?vue&type=script&lang=js&"
export * from "./PersonalAccidentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3d8d80",
  null
  
)

export default component.exports